import { jsx as _jsx } from "react/jsx-runtime";
import { StyledStackItem } from "./Item.styled";
export var Item = function (props) {
    var children = props.children, _a = props.hasFill, hasFill = _a === void 0 ? false : _a;
    return _jsx(StyledStackItem, { hasFill: hasFill, children: children });
};
